import styled from 'styled-components';

export const Container = styled.div`
  background-color: var(--black-025);
  border-top: 2px solid rgba(247, 195, 37, 0.8);
  margin-bottom: 2px;
  box-sizing: border-box;
  box-shadow: 0 1px 0 rgba(12, 13, 14, 0.15);
  transition: box-shadow cubic-bezier(0.165, 0.84, 0.44, 1) 0.25s;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  max-width: 1200px;
  padding: 25px 30px;
  margin: 0 auto;
  

  @media (max-width: 768px) {
    padding: 0 5px;
  }

  img {
    max-height: 30px;
    cursor: pointer;
  }

  nav {
    display: flex;
    align-items: center;

    img {
      margin-right: 20px;
      padding-right: 20px;
      max-width: 170px;
      border-right: 1px solid #eee;
    }
  }

  aside {
    display: flex;
    align-items: center;
  }
`;

export const Profile = styled.div`
  display: flex;

  @media (max-width: 768px) {
    max-width: 40%;
  }

  @media (max-width: 568px) {
    max-width: 35%;
  }

  strong {
    font-size: 18px;
    padding: 5px 20px 0 0;

    @media (max-width: 768px) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  img {
    max-width: 30px;
    max-height: 30px;
    cursor: pointer;
  }
`;
